import React from "react";
import { Button } from "@/components/ui/button";
import { PlusCircle } from "lucide-react";

interface HeaderSectionProps {
  onCreateClick: () => void;
}

export const HeaderSection: React.FC<HeaderSectionProps> = ({ onCreateClick }) => {
  return (
    <div className="flex justify-between items-center">
      <h1 className="text-3xl font-bold text-white">Meus Serviços</h1>
      <Button 
        className="bg-[#00B6F0] text-black hover:bg-[#00A3D9]"
        onClick={onCreateClick}
      >
        <PlusCircle className="mr-2 h-4 w-4" /> Novo Serviço
      </Button>
    </div>
  );
};
